import { Container, Row, Col } from "react-bootstrap";

import trafficControl1 from '../../assets/img/traffic-control-2026-1.jpg';
import trafficControl2 from '../../assets/img/traffic-control-2026-2.jpg';

// Newest first. To add an announcement, put a new entry at the top.
const announcements = [
    {
        date: '2026.09.29',
        img: trafficControl1,
        tag: { Chinese: '交通管制', English: 'Traffic Control' },
        title: {
            Chinese: '10/3 交通管制公告：管制時間與路段',
            English: 'Oct 3 Traffic Control: Closure Times & Roads',
        },
        summary: {
            Chinese: '台21線 60.5K 至 68.5K 於 05:30–07:00 全線封閉，周邊路段 05:00–15:00 實施交通管制。',
            English: 'Hwy 21 (60.5K–68.5K) fully closed 05:30–07:00; surrounding roads under traffic control 05:00–15:00.',
        },
    },
    {
        date: '2026.09.29',
        img: trafficControl2,
        tag: { Chinese: '交通管制', English: 'Traffic Control' },
        title: {
            Chinese: '10/3 交通管制公告：停車場位置圖',
            English: 'Oct 3 Traffic Control: Parking Map',
        },
        summary: {
            Chinese: '選手、工作人員及貴賓停車場位置，以及 04:00–15:00 開放路邊停車路段。',
            English: 'Parking for riders, staff and guests, plus roadside parking open 04:00–15:00.',
        },
    },
];

export const LatestNews = ({ language }) => {
    const lang = language === "Chinese" ? "Chinese" : "English";

    return (
        <section className="latest-news" id="latest-news">
            <Container>
                <div className="news-bx">
                    <h2>{lang === "Chinese" ? "最新公告" : "Latest Announcements"}</h2>
                    <Row className="g-4 justify-content-center">
                        {announcements.map((item, index) => (
                            <Col xs={12} md={6} lg={5} key={index}>
                                <a className="news-card" href={item.img} target="_blank" rel="noopener noreferrer">
                                    <img src={item.img} alt={item.title[lang]} loading="lazy" />
                                    <div className="news-card-body">
                                        <div className="news-meta">
                                            <span className="news-tag">{item.tag[lang]}</span>
                                            <span>{item.date}</span>
                                        </div>
                                        <h5>{item.title[lang]}</h5>
                                        <p className="mb-2">{item.summary[lang]}</p>
                                        <span className="news-more">{lang === "Chinese" ? "點我看完整公告" : "View full notice"}</span>
                                    </div>
                                </a>
                            </Col>
                        ))}
                    </Row>
                </div>
            </Container>
        </section>
    )
}
